import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

angular
  .module('bringoz.admin.auctions')
  .factory('AuctionsAPI', AuctionsAPI);

function AuctionsAPI(): BringozApi {
  return {
    base: `/auctions`,
    infiniteScroll: {
      address: `/auctions`,
      cmd: 'GET'
    },
    actions: {
      getDeliveryAuctions: {
        address: '',
        cmd: 'GET'
      },
      createAuction: {
        address: '{id}/create',
        cmd: 'POST'
      },
      /**
       * @param aid - auction ID
       * @param aoid - auction offer ID
       * **/
      acceptOffer: {
        address: '{aid}/{aoid}/accept',
        cmd: 'POST'
      },
      rejectOffer: {
        address: '{aid}/{aoid}/reject',
        cmd: 'POST'
      }
    }
  }
}
